import { FC } from 'react';
import cx from 'classnames/bind';

import PacksTime from '@/assets/packsTime.png';
import { Modal } from '@/components/Modal';

import styles from './ModalTimeIsUp.module.scss';

interface ModalTimeIsUpProps {
  modal: string;
  setModal: (value: string) => void;
  setStep: (value: number) => void;
  setFirstPlay: (value: boolean) => void;
}

const cn = cx.bind(styles);

const ModalTimeIsUp: FC<ModalTimeIsUpProps> = ({
  modal,
  setModal,
  setStep,
  setFirstPlay,
}) => {
  const handleClick = () => {
    setStep(3);
    setModal('');
    setFirstPlay(true);
  };

  return modal === 'timeIsUp' ? (
    <Modal
      src={PacksTime}
      title="Время на сборку заказа закончилось"
      textButton="Продолжить"
      handleClick={() => handleClick()}
    >
      <div className={cn('modal-description')}>
        <p className={cn('modal-text')}>
          К сожалению, вы не успели вовремя собрать заказ. Попробуйте еще раз.
        </p>
      </div>
    </Modal>
  ) : null;
};

export default ModalTimeIsUp;
